import ButtonPrimary from "components/Button/ButtonPrimary";
import Logo from "components/Logo/Logo";
import SocialsList from "components/SocialsList/SocialsList";
import gbFlagImg from "images/finvue/gb-flag.png";
import React, { FC, ReactNode } from "react";
import Image from "../Image";

export interface SectionHeroProps {
  className?: string;
  rightImg?: string;
  leftImg?: string;
  centerImg?: string;
  centerImgClasses?: string;
  topHeading?: ReactNode;
  heading: ReactNode;
  subHeading: string;
  btnTextPrimary: string;
  btnPrimaryUrl?: string;
  btnTextSecondary?: string;
  btnSecondaryUrl?: string;
  subHeadingColor?: string;
}

const SectionHero: FC<SectionHeroProps> = ({
  className = "",
  rightImg,
  leftImg,
  centerImg,
  topHeading,
  heading,
  centerImgClasses,
  subHeading,
  btnTextPrimary,
  btnPrimaryUrl = "/",
  btnTextSecondary,
  btnSecondaryUrl = "/",
  subHeadingColor = "text-neutral-6000 dark:text-neutral-400",
}) => {
  const renderContent = () => (
    <div className={`mx-auto w-full max-w-7xl space-y-5 lg:space-y-7 ${!centerImg ? "pt-32 md:pt-6" : "py-32"}`}>
      <h1 className="text-base tracking-widest font-semibold -mb-2 md:-mb-6 uppercase">{topHeading}</h1>
      <h2 className="text-xl !leading-tight font-semibold text-neutral-900 md:text-4xl xl:text-5xl dark:text-neutral-100">{heading}</h2>

      <span className={`block text-base xl:text-lg ${subHeadingColor}`}>{subHeading}</span>
      <div className={`flex space-x-4 ${!centerImg ? "justify-center md:justify-start" : "justify-center"}`}>
        {!!btnTextPrimary && <ButtonPrimary href={btnPrimaryUrl}>{btnTextPrimary}</ButtonPrimary>}
        {!!btnTextSecondary && (
          <ButtonPrimary href={btnSecondaryUrl} className="bg-transparent border border-white text-white hover:bg-white hover:text-black">
            {btnTextSecondary}
          </ButtonPrimary>
        )}
      </div>
      {/* <div className="flex justify-center items-center">
        <div className=" text-2xl py-2 px-4 rounded-xl font-semibold text-white">Coming Soon</div>
      </div> */}
    </div>
  );

  return (
    <div className={`nc-SectionHero relative  ${className}`}>
      {/* Center Image Layout */}
      {centerImg && (
        <div>
          <div className="relative flex flex-col items-center text-center min-h-screen">
            <Image className={`absolute inset-0 w-full h-full object-cover object-top lg:object-bottom z-0 ${centerImgClasses}`} src={centerImg} alt="About Us" />
            <div className="container relative z-10 space-y-7 ">
              <div className=" flex-1 flex flex-col justify-center">
                <div className="max-w-5xl mx-auto pt-20">{renderContent()}</div>
              </div>
              <div className="">
                <div className="mx-auto pb-8 mb-2 border-b border-gray-700 flex items-center justify-between">
                  <div className="flex items-center">
                    <Logo className="w-32 h-auto" />
                  </div>
                  <div className="flex items-center space-x-8">
                    <SocialsList className="flex items-center space-x-4" />
                  </div>
                </div>
                <div className="relative">
                  {/* Fading effect */}
                  <div className="absolute md:hidden top-0 right-0 h-full w-16 bg-gradient-to-l to-transparent pointer-events-none"></div>
                </div>
                <div className="text-left mt-4 text-white text-sm">
                  <div className="flex items-center space-x-4">
                    <a href="/privacy-policy" className=" text-white hover:text-gray-200">
                      Privacy Policy
                    </a>
                    <a href="/terms-and-conditions" className=" text-white hover:text-gray-200">
                      Terms and Conditions
                    </a>
                  </div>
                  <p className="text-sm py-4">
                    Copyright 2025, All Rights Reserved by Taupe Global Systems Ltd. Taupe Global Systems Ltd trading as FinVue. Registered Office: Level 18, 40 Bank Street, Canary Wharf, London, England, E14 5NR. Company Registration Number:
                    14978273. Registered in England and Wales.
                  </p>
                  <p className="text-sm py-4">Authorised and regulated by the Finacial Conduct Authority under reference number: 903135</p>
                  {/* <p className="py-4">
                    You can read more about our Terms and Policies by clicking{" "}
                    <a href="##" className="underline hover:text-gray-400 ">
                      here
                    </a>
                    .
                  </p> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Left Image Layout */}
      {!centerImg && leftImg && (
        <div className="flex flex-col lg:flex-row-reverse space-y-14 lg:space-y-0 lg:space-x-reverse lg:space-x-10 items-center lg:items-start text-center lg:text-left">
          <div className="lg:w-1/2 flex-grow flex justify-center items-center">
            <Image width={320} height={610} className="w-full" src={leftImg} alt="left" />
          </div>
          <div className="w-full flex-grow">{renderContent()}</div>
        </div>
      )}

      {/* Right Image Layout */}
      {!centerImg && rightImg && !leftImg && (
        <div className="flex flex-col lg:flex-row space-y-14 lg:space-y-0 items-center text-center lg:text-left">
          <div className="w-full flex-grow">{renderContent()}</div>
          <div className="w-full flex justify-center items-center overflow-hidden">
            <Image width={320} height={610} className="max-w-sm md:max-w-xs py-0 md:py-14 -mb-80 md:-mb-0 animate-slide-up-mobile md:animate-fade-in-desktop" src={rightImg} alt="right" />
          </div>
        </div>
      )}
    </div>
  );
};

export default SectionHero;
